import { parseDocumentFromString } from 'anodum';

import instance from './instance';
import eventListeners from './listeners/event-listeners';
import customEventListeners from './listeners/custom-event-listeners';

const initWith = (html) => {
  const currentLiveDocument = instance.driver.getLiveDocument();

  // Before init new page we remove all events listeners,
  // but browser native event still works (for example click on <a/> tag),
  // to prevent firing events we add `pointer-events: none` to body
  if (currentLiveDocument) {
    currentLiveDocument.body.classList.add('ws-no-events');
  }

  eventListeners.reset();
  customEventListeners.reset();
  instance.driver.reset();

  instance.driver.connectStaticDocument(parseDocumentFromString(html, false));
  instance.driver.composeLiveDocument();

  return instance.driver.getLiveDocument();
};

export default initWith;
